<template>
  <div class="c-pkg-item" :class="`${pkg.tag}`">
    <img
      class="cpi-tag"
      v-if="pkg.tag === 'recommend'"
      src="@/assets/images/price/ico-hot.png"
      alt=""
    />
    <div class="cpi-name">{{ pkg.name }}</div>
    <div class="cpi-desc">{{ pkg.desc }}</div>
    <div class="cpi-split"></div>
    <div class="cpi-price">
      <span class="num">¥{{ pkg.price }}</span>
      <span class="unit">{{ pkg.priceUnit }}({{ pkg.priceLimit }})</span>
      <!-- <span class="limit"></span> -->
      <!-- <div class="cpi-price-limit">({{ pkg.priceLimit }})</div> -->
    </div>
    <div
      class="cpi-price-feature"
      v-for="(item, index) in pkg.feature"
      :key="index"
    >
      <img class="cpi-price-feature__icon" :src="item.icon" alt="" />
      <span class="cpi-price-feature__text">{{ item.text }}</span>
    </div>

    <div v-if="pkg.disabled" class="btn disabled-btn">
      {{ pkg.mainButtonText }}
    </div>
    <kd-button
      v-else
      class="btn"
      :class="pkg.tag === 'recommend' ? 'primary-btn' : 'black-border-btn'"
      @click="contactSales"
    >
      {{ pkg.mainButtonText }}
    </kd-button>
  </div>
</template>

<script>
import { getFromPage, getPageName } from '@/common/utils/index';
import infoCollect from '@/common/infoCollect';
import { isEnvMobile } from '@/common/utils';

export default {
  name: 'PackageComponent',
  props: {
    pkg: Object,
    isLiuziPage: Boolean,
  },
  data() {
    return {};
  },
  inject: ['getChannel'],
  computed: {
    channel() {
      return this?.getChannel();
    },
  },
  methods: {
    contactSales() {
      if (this.isLiuziPage) {
        infoCollect.setAppEndExtraData(
          'button_click',
          'buy_' + this.pkg.type,
          isEnvMobile() ? (isIOS ? 'ios' : 'android') : 'PC',
          {
            page_name: 'pay_sales_retention',
            client_channel: this.channel,
          },
        );
      } else {
        infoCollect.dwCollectData(
          'button_click',
          this.pkg.event,
          isEnvMobile() ? (isIOS ? 'ios' : 'android') : 'PC',
          {
            page_name: getPageName(),
            from_item: getFromPage(),
          },
        );
      }

      const { mainButtonUrl } = this.pkg || {};

      if (this.isLiuziPage) {
        window.open(mainButtonUrl, '_self');
        return;
      }

      window.open(mainButtonUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-pkg-item {
  display: inline-block;
  width: 282px;
  height: 545px;
  background: #ffffff;
  border-radius: 8px;
  padding: 24px 32px;
  position: relative;
  box-shadow: 0px 4px 20px 0px rgba(13, 13, 13, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.08);

  &.recommend {
    margin-right: 0;
    background: #fff
      linear-gradient(
        180deg,
        rgba(30, 95, 199, 0.1) 0%,
        rgba(30, 95, 199, 0) 100%
      );
    background-size: 282px 104px;
    background-repeat: no-repeat;
    .cpi-name {
      color: var(--kd-color-text-public, rgba(30, 95, 199, 1));
    }
  }

  // @include screen_xs {
  //   width: 264px;
  // }

  // @include screen_s {
  //   width: 264px;
  // }

  // @include screen_m {
  //   width: 264px;
  // }

  // @include screen_l {
  //   width: 264px;
  // }

  // @include screen_xl {
  //   width: 264px;
  // }

  .cpi-tag {
    top: 22px;
    right: -10px;
    width: 44px;
    height: 44px;
    position: absolute;
  }
  .cpi-name {
    font-weight: 700;
    font-size: 24px;
    line-height: 38px;
    color: rgba(13, 13, 13, 0.9);
    text-align: center;
  }

  .cpi-desc {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 16px;
    color: rgba(13, 13, 13, 0.66);
    text-align: center;
    width: 106%;
    left: -3%;
    position: relative;
  }

  .cpi-price {
    font-size: 14px;
    line-height: 48px;
    color: rgba(13, 13, 13, 0.9);
    position: relative;
    height: 132px;
    padding: 24px 0;
    box-sizing: border-box;
    text-align: center;
    .num {
      font-size: 48px;
      font-weight: 700;
      line-height: 48px;
      display: block;
    }

    .unit {
      font-size: 16px;
      line-height: 26px;
      font-weight: 400;
      color: rgba(13, 13, 13, 0.66);
      display: inline-block;
    }
  }

  .cpi-split {
    width: 100%;
    height: 1px;
    background: rgba(13, 13, 13, 0.9);
    opacity: 0.1;
    // margin-top: 24px;
    // margin-bottom: 33px;
  }

  .cpi-price-feature {
    margin-bottom: 8px;
    position: relative;
    display: flex;
    align-items: center;

    &__icon {
      display: block;
      width: 16px;
      height: auto;
      margin-right: 10px;
      margin-top: -1px;
    }

    &__text {
      height: 22px;
      line-height: 22px;
      font-size: 13px;
      font-weight: 400;
      color: var(--kd-color-text-primary, rgba(13, 13, 13, 0.9));
    }
  }

  .btn {
    height: 40px;
    text-align: center;
    font-weight: 600;
    position: absolute;
    left: 30px;
    right: 40px;
    bottom: 40px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    width: calc(100% - 60px);
  }

  .disabled-btn {
    background-color: rgb(242, 242, 242);
    line-height: 48px;
  }
}
</style>
